var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatherFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.778,
    height: 17,
    viewBox: "0 0 18.778 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-filter",
    "data-name": "Icon feather-filter",
    d: "M20.778,4.5H3l7.111,8.409v5.813L13.667,20.5V12.909Z",
    transform: "translate(-2.5 -4)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherFilter);
export default __webpack_public_path__ + "static/media/feather-filter.61aa26f29f49d64c96e31dc89297818d.svg";
export { ForwardRef as ReactComponent };